// 9fbef606107a605d69c0edbcd8029e5d
import {
  JUST_A_FEW_LEFT_PRIORITY,
  INFLUENCER_PICKS_PRIORITY,
  BEST_SELLER_PRIORITY,
  TOP_RATED_PRIORITY,
  MOST_FAVORITED_PRIORITY,
  PREVIOUSLY_PURCHASED_PRIORITY,
  CLEARANCE_PRIORITY,
  REGULAR_TYPE,
  TOP_RATED_TYPE,
} from '@tcp/core/src/constants/badge.constants';
import { getDateObject, isCanada } from './utils';
import {
  GLOBAL_COMMON_BROWSE_LABELS,
  globalCommonBrowseLabels,
  lblBestSeller,
  lblClearance,
  lblFewLeft,
  lblGlowInDark,
  lblMatchingFamily,
  lblMostFavorited,
  lblNew,
  lblOnlineOnly,
  lblTopRated,
  lblPreviouslyPurchased,
  lblOnlineExclusive,
} from './labels/globalCommonBrowseLabels.labels';
import { getLabelFromCopyOrFromTranslation, getLabelWithDefaultValue } from './labels/labelUtilty';

const NEW_ARRIVALS = 'New Arrivals';

// Attributes for PLP/PDP and Cart apis are different hence there was a need to create this.
export const parseBoolean = (bool) => {
  return bool === true || bool === '1' || (bool || '').toUpperCase() === 'TRUE';
};

const labels = {
  WEEK_DAYS: ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'],
  MONTHS: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
  MONTHS_SMALL: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ],
  WEEK_DAYS_SMALL: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
};

/**
 * @method getDateInformation
 * @desc returns day, month and day of the respective date provided
 * @param {string} date date which is to be mutated
 * @param {upperCase} date determines case
 */

export const getDateInformation = (date, upperCase) => {
  const currentDate = date ? getDateObject(date) : getDateObject();
  return {
    // added a case for upper and lower case values
    day: upperCase
      ? labels.WEEK_DAYS[currentDate.getDay()]
      : labels.WEEK_DAYS_SMALL[currentDate.getDay()],
    month: upperCase
      ? labels.MONTHS[currentDate.getMonth()]
      : labels.MONTHS_SMALL[currentDate.getMonth()],
    date: currentDate.getDate(),
  };
};

export const getCartProductAttributes = () => {
  const isUSStore = !isCanada();
  return isUSStore
    ? {
        onlineOnly: 'webOnlyFlagUSStore',
        clearance: 'itemTCPProductIndUSStore',
        glowInTheDark: 'itemTCPGlowInDarkUSStore',
        limitedQuantity: 'inventoryMessageUSStore',
      }
    : {
        onlineOnly: 'webOnlyFlagCanadaStore',
        clearance: 'itemTCPProductIndCanadaStore',
        glowInTheDark: 'itemTCPGlowInDarkCanadaStore',
        limitedQuantity: 'inventoryMessageCanadaStore',
      };
};

export const getCustomCartProductAttributes = () => {
  return {
    onlineOnly: 'c_TCPWebOnlyFlagStore',
    clearance: 'c_TCPProductIndStore',
    glowInTheDark: 'itemTCPGlowInDarkUSStore',
    limitedQuantity: 'inventoryMessageUSStore',
  };
};

export const getPLPProductAttributes = () => {
  const isUSStore = !isCanada();
  return isUSStore
    ? {
        merchant: 'TCPMerchantTagUSStore',
        onlineOnly: 'TCPWebOnlyFlagUSStore',
        clearance: 'TCPProductIndUSStore',
        glowInTheDark: 'TCPGlowInDarkUSStore',
        limitedQuantity: 'TCPInventoryMessageUSStore',
        extendedSize: 'TCPFitMessageUSStore',
        matchingCategory: 'TCPProductFlagUSStore',
        matchingFamily: 'TCPMatchingFamilyUSStore',
        primaryBrand: 'TCPPrimaryBrandUSStore',
        styleQty: 'TCPStyleQTYUS',
        styleType: 'TCPStyleTypeUS',
        isLicensed: 'isLicensed',
        bigIdeaLicensedProductBrand: 'TCPBigIdeaLicensedProductBrand',
      }
    : {
        merchant: 'TCPMerchantTagCanadaStore',
        onlineOnly: 'TCPWebOnlyFlagCanadaStore',
        clearance: 'TCPProductIndCanadaStore',
        glowInTheDark: 'TCPGlowInDarkUCanadaStore',
        limitedQuantity: 'TCPInventoryMessageCanadaStore',
        extendedSize: 'TCPFitMessageCanadaStore',
        matchingCategory: 'TCPProductFlagCAStore',
        matchingFamily: 'TCPMatchingFamilyCAStore',
        primaryBrand: 'TCPPrimaryBrandCanadaStore',
        styleQty: 'TCPStyleQTYCA',
        styleType: 'TCPStyleTypeCA',
        isLicensed: 'isLicensed',
        bigIdeaLicensedProductBrand: 'TCPBigIdeaLicensedProductBrand',
      };
};

export const getProductAttributes = () => {
  const isUSStore = !isCanada();
  return isUSStore
    ? {
        sizes: 'TCPSizeUSStore',
        swatches: 'TCPSwatchesUSStore',
        inventory: 'TCPInventoryFlagUSStore',
        onModelAltImages: 'TCPMarketingText1USStore',
        bossProductDisabled: 'TcpBossProductDisabled',
        bossCategoryDisabled: 'TcpBossCategoryDisabled',
        videoUrl: 'TCPMarketingText2USStore',
        keepAlive: 'TCPOutOfStockFlagUSStore',
        preOrderDate: 'TCPPreOrderDateUSStore',
        variantPreOrderDate: 'variantPreOrderDateUS',
        ...getPLPProductAttributes(),
      }
    : {
        sizes: 'TCPSizeCanadaStore',
        swatches: 'TCPSwatchesCanadaStore',
        inventory: 'TCPInventoryFlagCanadaStore',
        onModelAltImages: 'TCPMarketingText1CanadaStore',
        videoUrl: 'TCPMarketingText2CanadaStore',
        keepAlive: 'TCPOutOfStockFlagCanadaStore',
        preOrderDate: 'TCPPreOrderDateCanadaStore',
        variantPreOrderDate: 'variantPreOrderDateCA',
        ...getPLPProductAttributes(),
      };
};

export const attributeListMaker = (attributes) => {
  const regexUrl = /((http|https):\/\/)?(([\w.-]*)\.([\w])).*/g;
  const specialAttributes = new Set([
    'topRatedCategories',
    'FeaturedCategories',
    'mostFavoritedCategories',
    'variantDetails',
  ]);

  return attributes.split(';').map((attribute) => {
    const match = attribute.match(regexUrl);
    const isUrl = match !== null;
    const url = match && match[0].split('|');
    const attAndValue = attribute.split(':');
    const identifier = attAndValue[0];

    if (specialAttributes.has(identifier)) {
      const attrAndValue = attribute.split(/:(.*)/s);
      return { identifier: attrAndValue[0], value: attrAndValue[1] };
    }

    return { identifier, value: isUrl ? url : attAndValue[1] };
  });
};

export const extractAttributeValue = (item, attribute) => {
  let obj = '';
  try {
    if (item.list_of_attributes) {
      const currItm = item.list_of_attributes;
      /* item.list_of_attributes comes as Array on PLP but on PDP it comes as a string when this function is called. On PLP we have a wrapper funtion where
      we do the modifcation and pass the data to this function but on PDP we do not have a wrapper function in this module hence handeling the PDP at this
      place only. */
      const itm = Array.isArray(currItm) ? currItm : attributeListMaker(currItm);
      const ele = itm.find((att) => att.identifier === attribute);
      obj = ele && ele.value;
    } else if (item[attribute]) {
      obj = item[attribute];
    }
  } catch (error) {
    //
  }
  return obj;
};

export const extractAttributeValuesOptimized = (item, attributes) => {
  const values = {};
  try {
    if (item.list_of_attributes) {
      const currItm = item.list_of_attributes;
      const itm = Array.isArray(currItm) ? currItm : attributeListMaker(currItm);
      attributes.forEach((attribute) => {
        const ele = itm.find((att) => att.identifier === attribute);
        values[attribute] = ele && ele.value;
      });
    } else {
      attributes.forEach((attribute) => {
        values[attribute] = item[attribute];
      });
    }
  } catch (error) {
    // handle error
  }
  return values;
};

export const checkMatchingFamily = (matchingFamily, excludeBadge, siteAttributes) => {
  if (matchingFamily && excludeBadge !== siteAttributes.matchingFamily) {
    return matchingFamily;
  }
  return false;
};

// function
function getAllLangConsts(categoryType) {
  return Object.keys(categoryType).map((key) => categoryType[key]);
}

/* Below functions are used to check whether to show/hide clearance/New Arrivals/Online Only badges in both en and translated sites.
Doing this as motion point is translating the categories in the redux store */
export const LANG_STRINGS = {
  PRODUCTS: {
    ATTRIBUTES: {
      CLEARANCE: {
        en: 'Clearance',
        fr: 'Liquidation',
        es: 'Liquidación',
      },
      ONLINE_ONLY: {
        en: 'Online Only',
        fr: 'Online Only', // Added english word as we dont have online only for ca-fr
        es: 'Solo en línea',
      },
      NEW_ARRIVALS: {
        en: NEW_ARRIVALS,
        fr: 'Nouvelles Arrivées',
        es: 'Los recién llegados',
      },
    },
  },
};

// function to select the corresponding category
export function getClearanceString(categoryType) {
  return getAllLangConsts(LANG_STRINGS.PRODUCTS.ATTRIBUTES[categoryType]);
}

const getCustomBadge = (product, siteAttributes) => {
  const attributes = [
    'topRatedCategories',
    'FeaturedCategories',
    'mostFavoritedCategories',
    siteAttributes.merchant,
    siteAttributes.extendedSize,
  ];
  const values = extractAttributeValuesOptimized(product, attributes);
  const customBadges = {};

  if (values.topRatedCategories) {
    customBadges.topRatedBadge = { categories: values.topRatedCategories };
  }
  if (values.mostFavoritedCategories) {
    customBadges.mostFavoritedBadge = { categories: values.mostFavoritedCategories };
  }
  if (values.FeaturedCategories) {
    customBadges.isBestSeller = { categories: values.FeaturedCategories };
  }
  if (values[siteAttributes.merchant]) {
    customBadges.merchantTag = values[siteAttributes.merchant];
  }
  if (values[siteAttributes.extendedSize]) {
    customBadges.extendedSize = values[siteAttributes.extendedSize];
  }

  return customBadges;
};

export function extractZoneOneBadges(product, siteAttributes, categoryType) {
  const isLimitedQuantity =
    extractAttributeValue(product, siteAttributes.limitedQuantity) === 'limited quantities';
  const clearanceOrNewArrival = extractAttributeValue(product, siteAttributes.clearance);
  const isClearance =
    clearanceOrNewArrival === 'Clearance' &&
    !getClearanceString('CLEARANCE').includes(categoryType);
  const globalCommonLabels =
    getLabelFromCopyOrFromTranslation(GLOBAL_COMMON_BROWSE_LABELS, globalCommonBrowseLabels) || {};

  const zoneOneBadges = [];
  if (isLimitedQuantity) {
    zoneOneBadges.push({
      label: getLabelWithDefaultValue(globalCommonLabels, lblFewLeft),
      priority: JUST_A_FEW_LEFT_PRIORITY,
      canBePairedWithOtherBadges: false,
      type: REGULAR_TYPE,
    });
  }
  if (isClearance) {
    zoneOneBadges.push({
      label: getLabelWithDefaultValue(globalCommonLabels, lblClearance),
      priority: CLEARANCE_PRIORITY,
      canBePairedWithOtherBadges: true,
      type: REGULAR_TYPE,
    });
  }
  return zoneOneBadges;
}

function sortAndFilterArray(arr) {
  if (!arr || !arr.length) {
    return [];
  }

  if (arr.length === 1) {
    return arr;
  }

  arr.sort((a, b) => a.priority - b.priority);
  const firstObj = arr[0];
  if (firstObj.displaySingleBadge) {
    return [firstObj];
  }

  if (firstObj.canBePairedWithOtherBadges) {
    const secondObj = arr[1];
    if (secondObj.displaySingleBadge) {
      const nextBadgeToDisplay = arr.find((obj, index) => index > 1 && !obj.displaySingleBadge);

      return nextBadgeToDisplay ? [firstObj, nextBadgeToDisplay] : [firstObj];
    }
    return [firstObj, secondObj];
  }

  const secondObj = arr.find((obj, index) => index > 0 && obj.canBePairedWithOtherBadges);
  return secondObj ? [firstObj, secondObj] : [firstObj];
}

export const getZoneOneBadgesArray = ({
  zoneOneBadges,
  topRatedBadge,
  bestSellerBadge,
  mostFavoritedBadge,
  influencerPickToDisplay,
  previouslyPurchasedBadge,
}) => {
  const globalCommonLabels =
    getLabelFromCopyOrFromTranslation(GLOBAL_COMMON_BROWSE_LABELS, globalCommonBrowseLabels) || {};

  const zoneOneBadgesArray = zoneOneBadges ? [...zoneOneBadges] : [];
  if (topRatedBadge) {
    zoneOneBadgesArray.push({
      label: getLabelWithDefaultValue(globalCommonLabels, lblTopRated),
      priority: TOP_RATED_PRIORITY,
      canBePairedWithOtherBadges: true,
      type: TOP_RATED_TYPE,
    });
  }
  if (bestSellerBadge) {
    zoneOneBadgesArray.push({
      label: getLabelWithDefaultValue(globalCommonLabels, lblBestSeller),
      priority: BEST_SELLER_PRIORITY,
      canBePairedWithOtherBadges: false,
    });
  }
  if (mostFavoritedBadge) {
    zoneOneBadgesArray.push({
      label: getLabelWithDefaultValue(globalCommonLabels, lblMostFavorited),
      priority: MOST_FAVORITED_PRIORITY,
      canBePairedWithOtherBadges: false,
    });
  }

  if (influencerPickToDisplay) {
    zoneOneBadgesArray.push({
      label: influencerPickToDisplay,
      priority: INFLUENCER_PICKS_PRIORITY,
      displaySingleBadge: true,
      canBePairedWithOtherBadges: false,
    });
  }
  if (previouslyPurchasedBadge) {
    zoneOneBadgesArray.push({
      label: getLabelWithDefaultValue(globalCommonLabels, lblPreviouslyPurchased),
      priority: PREVIOUSLY_PURCHASED_PRIORITY,
      type: TOP_RATED_TYPE,
      canBePairedWithOtherBadges: true,
    });
  }
  return sortAndFilterArray(zoneOneBadgesArray);
};

export const extractZoneSixBadges = (product, siteAttributes, categoryType, isBundleProduct) => {
  const globalCommonLabels =
    getLabelFromCopyOrFromTranslation(GLOBAL_COMMON_BROWSE_LABELS, globalCommonBrowseLabels) || {};

  const { matchingFamily, glowInTheDark, onlineOnly, clearance, extendedSize } = siteAttributes;

  const attributes = [matchingFamily, glowInTheDark, onlineOnly, clearance, extendedSize];
  const values = extractAttributeValuesOptimized(product, attributes);

  const matchingFamilyBadges = values[matchingFamily];
  const isGlowInTheDark = parseBoolean(values[glowInTheDark]);
  const isOnlineOnly = parseBoolean(values[onlineOnly]);
  const clearanceOrNewArrival = values[clearance];
  const extendedSizesBadge = isBundleProduct ? '' : values[extendedSize];

  if (matchingFamilyBadges) {
    return getLabelWithDefaultValue(globalCommonLabels, lblMatchingFamily);
  }

  if (isGlowInTheDark) {
    return getLabelWithDefaultValue(globalCommonLabels, lblGlowInDark);
  }

  if (extendedSizesBadge) {
    return extendedSizesBadge;
  }

  if (isOnlineOnly && !getClearanceString('ONLINE_ONLY').includes(categoryType)) {
    return getLabelWithDefaultValue(globalCommonLabels, lblOnlineOnly);
  }

  if (
    clearanceOrNewArrival === NEW_ARRIVALS &&
    !getClearanceString('NEW_ARRIVALS').includes(categoryType)
  ) {
    return getLabelWithDefaultValue(globalCommonLabels, lblNew);
  }

  return '';
};

// DT-708
// eslint-disable-next-line complexity
export function extractPrioritizedBadge(
  product,
  siteAttributes,
  categoryType,
  excludeBadge,
  hidePdpBadge
) {
  const attributes = [
    siteAttributes.matchingCategory,
    siteAttributes.matchingFamily,
    siteAttributes.glowInTheDark,
    siteAttributes.limitedQuantity,
    siteAttributes.onlineOnly,
    siteAttributes.clearance,
    hidePdpBadge ? null : siteAttributes.bundleChecklist,
  ].filter(Boolean); // remove null values

  const globalCommonLabels =
    getLabelFromCopyOrFromTranslation(GLOBAL_COMMON_BROWSE_LABELS, globalCommonBrowseLabels) || {};

  const values = extractAttributeValuesOptimized(product, attributes);

  const matchingCategory = values[siteAttributes.matchingCategory];
  const matchingFamily = values[siteAttributes.matchingFamily];
  const isGlowInTheDark = parseBoolean(values[siteAttributes.glowInTheDark]);
  const isLimitedQuantity = values[siteAttributes.limitedQuantity] === 'limited quantities';
  const isOnlineOnly = parseBoolean(values[siteAttributes.onlineOnly]);
  const clearanceOrNewArrival = values[siteAttributes.clearance];
  const bundleBadge = !hidePdpBadge ? values[siteAttributes.bundleChecklist] : '';

  let badges = {};
  const customBadges = getCustomBadge(product, siteAttributes);
  badges = { ...badges, ...customBadges };

  if (matchingFamily && excludeBadge !== siteAttributes.matchingFamily) {
    badges.matchBadge = matchingFamily;
  }
  if (bundleBadge) {
    badges.defaultBadge = bundleBadge;
  } else if (matchingCategory) {
    badges.defaultBadge = matchingCategory;
  } else if (isGlowInTheDark) {
    badges.defaultBadge = getLabelWithDefaultValue(globalCommonLabels, lblGlowInDark);
  } else if (isLimitedQuantity) {
    badges.defaultBadge = getLabelWithDefaultValue(globalCommonLabels, lblFewLeft);
  } else if (isOnlineOnly && !getClearanceString('ONLINE_ONLY').includes(categoryType)) {
    // TDB: node missing in service response, need to check it's possible values
    badges.defaultBadge = getLabelWithDefaultValue(globalCommonLabels, lblOnlineExclusive);
  } else if (
    clearanceOrNewArrival === 'Clearance' &&
    !getClearanceString('CLEARANCE').includes(categoryType)
  ) {
    // TDB: node missing in service response, need to check it's possible values
    badges.defaultBadge = getLabelWithDefaultValue(globalCommonLabels, lblClearance);
  } else if (
    clearanceOrNewArrival === NEW_ARRIVALS &&
    !getClearanceString('NEW_ARRIVALS').includes(categoryType)
  ) {
    // TDB: node missing in service response, need to check it's possible values
    badges.defaultBadge = `${getLabelWithDefaultValue(globalCommonLabels, lblNew)}!`;
  }

  return badges;
}
